import React, { Component } from 'react';
export default class Popup extends Component {
    render() {
        let popup = {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: 'auto',
            backgroundColor: 'rgba(0,0,0, 0.5)'
        }

        let popup_inner = {
            position: 'absolute',
            bottom: 70,
            right: 20,
            margin: 'auto',
            borderRadius: 10,
            background: 'white',
            padding: 10,
            textAlign: 'left'
        }

        let button_style = {
            backgroundColor: '#f3f3f3',
            padding: 10,
            width: 100,
            boxShadow: '0 0 2px black'
        }

        return (
            <div style={popup} onClick={this.props.closePopup}>
                <div style={popup_inner}>
                    <div style={button_style} onClick={this.props.handleUniview}>
                        <span>{this.props.univiewTitle}</span>
                    </div>
                    <div style={button_style} onClick={this.props.handleDLink}>
                        <span>{this.props.dlinkTitle}</span>
                    </div>
                </div>
            </div>
        );
    }
}